import React from "react";
import PatientIcon from "../../assets/images/patient.png";
import { getUserPictureUrl } from "../../utils/common_lib";
const PatientCard = ({
  name = "",
  sex = "",
  dob = "",
  provider = "",
  id = "",
  selected = false,
  handleSelected,
}) => {
  return (
    <div
      class={`rounded-2xl  ${
        selected && "bg-gray-200"
      } p-4 border-solid border border-gray-600 cursor-pointer hover:bg-gray-100 shadow-md`}
      onClick={handleSelected}>
      <div className="flex">
        <img
          src={getUserPictureUrl(id)}
          className="size-24 rounded-md"
          alt="patient"
        />
        <div className="ml-4">
          <h3 class="text-base text-start font-semibold leading-7 ">{name}</h3>

          <dl class="mt-3 space-y-1 text-sm leading-6 text-gray-600">
            <h6 class=" text-start font-semibold leading-7 capitalize">
              {sex} , {dob}
            </h6>
            <h6 class=" text-start font-semibold leading-7 ">
              Provider: {provider || "N/A"}
            </h6>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default PatientCard;
